import { render, staticRenderFns } from "./Basket.vue?vue&type=template&id=5bd007ba"
import script from "./Basket.vue?vue&type=script&lang=js"
export * from "./Basket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports